import type { MapStyleKey } from '../mapStyleUtils';
import type { ValidSearchType } from '../helpers/validateSearchTypes';

// The reducer owns only ephemeral UI keys: the linkable view keys are
// URL-canonical (useLinkableSearchState), the live viewport is map-owned
// (ViewportContext), and map movement goes through MapCommands.

export type LngLat = [number, number]; // [lng, lat] — Mapbox order

// Single-element array on purpose: the zoom is republished as a fresh array on
// every moveend, so readers key off the value while the map owns the number.
export type Zoom = [number];

export type FitBounds = number[][] | null;

export type SearchType = ValidSearchType | '';

export type CardProperties = {
  name?: string;
  type?: string;
  stackSize?: number;
};

// Ephemeral UI state.
export interface UiState {
  isCardActive: boolean;
  cardProperties: CardProperties;
  mapStyleKey: MapStyleKey;
}

export type ColdAppState = UiState;

export type AppAction =
  | { type: 'cardOpened'; cardProperties?: CardProperties }
  | { type: 'cardDismissed' }
  | { type: 'cardPropertiesChanged'; cardProperties: CardProperties }
  | { type: 'mapStyleChanged'; mapStyleKey: MapStyleKey };

export const appStateReducer = (state: ColdAppState, action: AppAction): ColdAppState => {
  switch (action.type) {
    case 'cardOpened':
      // Opening without properties keeps the current ones (HUD reopening);
      // opening with properties replaces them (map feature click).
      return {
        ...state,
        isCardActive: true,
        cardProperties: action.cardProperties ?? state.cardProperties,
      };
    case 'cardDismissed':
      return { ...state, isCardActive: false, cardProperties: {} };
    case 'cardPropertiesChanged':
      return { ...state, cardProperties: action.cardProperties };
    case 'mapStyleChanged':
      return { ...state, mapStyleKey: action.mapStyleKey };
  }
};
